import { render, staticRenderFns } from "./doc_preview.vue?vue&type=template&id=6828ab41"
import script from "./doc_preview.vue?vue&type=script&lang=js"
export * from "./doc_preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports